import EventBus from "./event-bus";

const axios = require('axios');

import {errorHandler} from "./common";

export function getMerchants() {
  return new Promise(function (resolve, reject) {
    // console.log("updateOrder ")
    axios.get(process.env.ROOT_API + 'admin/merchants', {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function (response) {
      let data = response['data'];
      // console.log("get Merchant List");
      // console.log(data);
      resolve(data);
    })
      .catch(error => {
        console.log("error to update");
        console.log(error.response);
        errorHandler(error);
        reject(error)
      });
  })
}

export function getMerchant(id) {
  return new Promise(function (resolve, reject) {
    // console.log("updateOrder ")
    axios.get(process.env.ROOT_API + 'admin/merchant?id=' + id, {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function (response) {
      let data = response['data'];
      // console.log("get Merchant List");
      // console.log(data);
      resolve(data);
    })
      .catch(error => {
        console.log("error to update");
        console.log(error.response);
        errorHandler(error);
        reject(error)
      });
  })
}

export function deleteMerchant(id) {
  return new Promise(function (resolve, reject) {
    // console.log("updateOrder ")
    axios.delete(process.env.ROOT_API + 'admin/merchant?id=' + id, {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function (response) {
      let data = response['data'];
      console.log("get Merchant List");
      console.log(data);
      resolve(data);
    })
      .catch(error => {
        console.log("error to update");
        console.log(error.response);
        errorHandler(error);
        reject(error)
      });
  })
}
export function activateMerchant(id, active) {
  return new Promise(function (resolve, reject) {
    // console.log("updateOrder ")
    axios.get(process.env.ROOT_API + 'admin/merchant/activate/' + id + '?activate=' + active, {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function (response) {
      let data = response['data'];
      // console.log("get Merchant List");
      // console.log(data);
      resolve(data);
    })
      .catch(error => {
        console.log("error to update");
        console.log(error.response);
        errorHandler(error);
        reject(error)
      });
  })
}
export function updateMerchant(merchant) {
  return new Promise(function (resolve, reject) {
    axios.post(process.env.ROOT_API + 'admin/merchant', JSON.stringify(merchant), {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function (response) {
      let data = response['data'];
      // console.log("Merchant Item update");
      // console.log(data);
      resolve(data);
    })
      .catch(error => {
        console.log("error to update");
        console.log(error.response);
        errorHandler(error);
        reject(error);
      });
  })
}
export function enableMerchantAPI(mId, enable) {
  return new Promise(function (resolve, reject) {
    EventBus.$emit("showLoading", true);
    axios.get(process.env.ROOT_API + 'admin/merchant/' + mId + "/guac/status?enable=" + enable, {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function (response) {
      EventBus.$emit("showLoading", false);
      let data = response['data'];
      // console.log("Merchant Item update");
      // console.log(data);
      resolve(data);
    })
      .catch(error => {
        EventBus.$emit("showLoading", false);
        console.log("error to update");
        console.log(error.response);
        errorHandler(error);
        reject(error);
      });
  })
}
export function updateDeliveryDate(item) {
  return new Promise(function (resolve, reject) {
    axios.post(process.env.ROOT_API + 'admin/deliveryDate', JSON.stringify(item), {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function (response) {
      let data = response['data'];
      // console.log("Delivery Date Item update");
      // console.log(data);
      resolve(data);
    })
      .catch(error => {
        console.log("error to update");
        console.log(error.response);
        errorHandler(error);
        reject(error);
      });
  })
}
export function getMerchantReport() {
  return new Promise(function(resolve, reject) {
    EventBus.$emit("showLoading", true);
    axios.get(process.env.ROOT_API + 'admin/merchants/report', {
      responseType: 'blob',
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN")
      }
    })
      .then(function(response){
        EventBus.$emit("showLoading", false);

        // console.log(response);
        resolve(response);
      })
      .catch(function(err) {
        EventBus.$emit("showLoading", false);
        errorHandler(err);
        reject(err);
      })
  })
}
export function updateMerchantBulk(list) {
  return new Promise(function(resolve, reject){
    EventBus.$emit("showLoading", true);
    axios.post(process.env.ROOT_API + 'admin/merchants/bulk', JSON.stringify(list), {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function(response){
      EventBus.$emit("showLoading", false);
      let data = response.data;
      // console.log("updateProductBulk")
      // console.log(data);
      resolve(data);
    }).catch(function(err){
      EventBus.$emit("showLoading", false);
      errorHandler(err);
      reject(err);
    })

  })
}
export function createNewMerchant() {
  let newItem = {
    id:0,
    type:'kokoro',
    title:'',
    companyName:'',
    companyNumber:'',
    vatNumber:'',
    userId:0,
    address:'',
    postCode:'',
    email:'',
    contactName:'',
    contact:'',
    description:'',
    emails:[],
    ccEmails:[],
    tags:[],
  }
  return newItem;
}

export function createNewMerchantUser(merchantId) {
  let newUser = {
    id:0,
    name:'',
    email:'',
    password:'',
    password2:'',
    merchantId:merchantId,
    role:'merchant',
    type:'merchant',
  }

  return newUser;
}

export function getTypeList() {
  let list = [
    {
      value:'kokoro',
      name:'KOKORO',
    },
    {
      value:'jv',
      name:'KV',
    },
    {
      value:'franchise',
      name:'FRANCHISE',
    },
    {
      value:'vendor',
      name:'VENDOR',
    },
    {
      value:'personal',
      name:'PERSONAL',
    }
  ]
  return list;
}



// WEBPACK FOOTER //
// ./src/api/merchant.js